import { CommonModule } from '@angular/common';
import {
  Component,
  inject,
  OnInit,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  ButtonComponent,
  ButtonSize,
  ButtonType,
  NativeButtonType,
} from '@app/components/button';
import {
  TextColor,
  TextComponent,
  TextHeight,
  TextSize,
  TextType,
  TextWeight,
} from '@app/components/text';
import {
  TextInputComponent,
  TextInputDirection,
  TextInputSize,
  TextInputType,
  TextInputWidth,
} from '@app/components/text-input';
import {
  ToastComponent,
  ToastPosition,
  ToastService,
  ToastType,
} from '@app/components/toast';
import { ViewAlign, ViewComponent, ViewDirection } from '@app/components/view';
import { Spacing, StatusCode } from '@app/shared/types';
import { AdminAuthService } from '../../../services/admin-auth/admin-auth.service';
import { emailRegex } from '../../../utils';

@Component({
  standalone: true,
  selector: 'app-sign-in',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css',
  imports: [
    TextInputComponent,
    TextComponent,
    ButtonComponent,
    CommonModule,
    RouterModule,
    ViewComponent,
    ToastComponent,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class ForgotPasswordComponent implements OnInit {
  private readonly adminAuthService = inject(AdminAuthService);
  private readonly messageService = inject(ToastService);
  email = signal('');
  requestSent = false;
  emailError = false;
  invalidFormatting = false;
  emailErrorMessage = '';
  invalidFormattingMessage = '';
  InputSize = TextInputSize;
  InputDirection = TextInputDirection;
  InputWidth = TextInputWidth;
  InputType = TextInputType;
  NativeButtonType = NativeButtonType;
  ButtonType = ButtonType;
  ButtonSize = ButtonSize;
  Spacing = Spacing;
  TextType = TextType;
  TextColor = TextColor;
  TextHeight = TextHeight;
  TextWeight = TextWeight;
  TextSize = TextSize;
  ViewDirection = ViewDirection;
  ViewAlign = ViewAlign;
  ToastPosition = ToastPosition;

  ngOnInit(): void {
    this.adminAuthService.clearToken();
  }

  submit(e: Event): void {
    e.preventDefault();
    this.emailError = false;
    this.emailErrorMessage = '';
    this.requestSent = false;
    this.invalidFormatting = false;
    this.invalidFormattingMessage = '';

    if (!emailRegex.test(this.email())) {
      this.emailError = true;

      if (!this.email()) {
        this.emailErrorMessage = 'Email is required.';
      } else {
        this.emailErrorMessage = 'Email is not valid.';
      }
    }

    if (this.emailError) {
      return;
    }

    this.adminAuthService
      .forgotPassword(this.email())
      .subscribe(async (data) => {
        if (data.code === StatusCode.NO_CONTENT) {
          this.requestSent = true;
        } else if (data.code === StatusCode.BAD_REQUEST) {
          this.invalidFormatting = true;
          this.invalidFormattingMessage =
            'Please make sure that your email is formatted correctly.';
        } else if (data.code === StatusCode.INTERNAL_SERVER_ERROR) {
          this.messageService.add(
            'Seems like there is an issue with the server. Please try again later.',
            ToastType.ERROR
          );
        } else {
          this.messageService.add(
            'Seems like there is an unknown issue. Please try again later.',
            ToastType.ERROR
          );
        }
      });
  }
}
